export const APP_VERSION = "v2.0.0";
// export const backendURL = document.getElementById("backend_url")?.getAttribute("content");
export const backendURL = "https://api.scandoc.ai/bo/";
// export const backendURL = "http://0.0.0.0:5000/";



console.log(`App version: ${APP_VERSION}`);
console.log(`Backend URL: ${backendURL}`);